var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UAVViewer',{ref:"viewer",attrs:{"project-id":_vm.projectId,"use-public-api":_vm.usePublicApi,"fullscreen":true,"controls-position":"side-left","show-subtitle":true,"show-photo-btn":true,"enable-annotation":true,"show-sandbox":true,"use-icons":true,"float-header":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }